import { useEffect, useRef } from 'react'

import { getConfigData } from 'utils/helpers/config'

export function useAnalyzer({
  audioCtx,
  sourceNode,
  gainNode,
}: {
  audioCtx: AudioContext | null
  sourceNode: MediaElementAudioSourceNode | null
  gainNode: GainNode | null
}) {
  const analyzer = useRef<AnalyserNode>()
  const audioConfig = getConfigData('audioConfig')

  useEffect(() => {
    if (!audioCtx || !audioConfig.showVisualizer) {
      return
    }
    analyzer.current = audioCtx.createAnalyser()
    sourceNode?.connect(analyzer.current)
    if (gainNode) {
      analyzer.current?.connect(gainNode)
    }
    analyzer.current.fftSize = audioConfig.fftSize
    return () => {
      if (analyzer.current) {
        sourceNode?.disconnect(analyzer.current)
        if (gainNode) {
          analyzer.current?.disconnect(gainNode)
        }
        analyzer.current = undefined
      }
    }
  }, [audioCtx, sourceNode, audioConfig.fftSize, gainNode])

  return analyzer.current
}
